import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Link, Stack, Paper, TextField, Box, Grid, Typography, Card, TableCell, TableContainer,
    Table, InputAdornment, TableHead, Button, IconButton, FormControl, CardContent, DialogContent, DialogTitle, Dialog,
    InputLabel, TableRow, TableBody, Snackbar, CircularProgress, AccordionDetails, MenuItem, Checkbox, Autocomplete, Tooltip, FormControlLabel, Accordion, AccordionSummary, Menu
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import SaveIcon from '@mui/icons-material/Save';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ERPinput, ERPinputNo } from './reusableComponent/ErpTextField';
import { StyledTableCell, StyledTableRow } from './reusableComponent/StyledTable';
import { addPurchaseInvoice, addSaleInvoice, editDeletePurchaseInvoice, editDeleteSaleInvoice, getAgeOfUnpaidInvoice, getCNSList, getItemList, getSalesItemDescriptionForManualEntry, getStateList, getTermsConditionsList, getUnitList, } from '../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import styles from '../styles.module.css';
import { dateConversionOnEntryPage, dateConversionOnEntryPageWithTime } from './reusableComponent/dateConversionOnEntryPage';
import { financialYear } from './reusableComponent/financialYear';
import { convertStringIntoTitleCase } from './reusableComponent/convertStringIntoTitleCase';
import Breadcrumb from './reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from './reusableComponent/BackBtn';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});

function DemoFile() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { handleSubmit } = useForm();
    const urlLocation = useLocation();
    let navigate = useNavigate();

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const prName = urlLocation.state.prName;
    const editInfo = urlLocation.state.row;
    const invoiceSetting = urlLocation.state.invoiceSettingList && urlLocation.state.invoiceSettingList[0];
    const backBtnLen = urlLocation.state.backBtn;
    const docNoFormateAvailable = urlLocation.state.docNoFormateAvailable;
    const termsList = urlLocation.state.termsList;

    const editData = editInfo && editInfo;
    const editid = editData ? editData.si_id : null;
    const [isUpdateArray, setIsUpdateArray] = useState(false);

    const [customerName, setCustomerName] = useState(editData ? editData.customerName : prName ? prName : null);
    const [successMessage, setSuccessMessage] = useState(null);

    const customerList = useSelector(state => state.CNS.CNS)
    const unitList = useSelector(state => state.unit.unit)
    const itemList = useSelector(state => state.item.item)
    const sales_itemDescription_forManualEntryList = useSelector(state => state.saleInvoice.sales_itemDescription_forManualEntry)
    const ageOfUnpaidInvoiceList = useSelector(state => state.saleInvoice.ageOf_unpaid_invoice)
    const stateList = useSelector(state => state.allStates.allStates)
    const lastEntryNo = useSelector(state => state.saleInvoice.lastEntryNo)

    const availTermsList = editData ? JSON.parse(editData.invoice_terms) : [];
    const [rowsTerms, setRowsTerms] = useState([]);

    const [isSet, setIsSet] = useState(false);
    const [invoiceDate, setInvoiceDate] = React.useState(editData ? dayjs(editData.invoiceDate) : dayjs(new Date()));
    const [challanDate, setChallanDate] = React.useState(editData ? dayjs(editData.challanDate) : dayjs(new Date()));
    const [orderRefDate, setOrderRefDate] = React.useState(editData ? dayjs(editData.orderRefDate) : dayjs(new Date()));

    const [basicTotal, setBasicTotal] = useState(editData ? editData.basicTotal : 0);
    const [gst, setGSt] = useState(editData ? editData.gst : 0);   // single gst %, if multiple tthen remove this
    const [gstTotal, setGstTotal] = useState(editData ? editData.gstTotal : 0);
    const [cgst, setCgst] = useState(editData ? editData.cgst : 0);
    const [sgst, setSgst] = useState(editData ? editData.sgst : 0);
    const [igst, setIgst] = useState(editData ? editData.igst : 0);
    const [cgstTotal, setCgstTotal] = useState(editData ? editData.cgstTotal : 0);
    const [sgstTotal, setSgstTotal] = useState(editData ? editData.sgstTotal : 0);
    const [igstTotal, setIgstTotal] = useState(editData ? editData.igstTotal : 0);
    const [shipAddress, setShipAddress] = useState({});
    const [billAddress, setBillAddress] = useState({});
    const [total, setTotal] = useState(editData ? editData.total : 0);
    const [round_off, setRound_off] = useState(editData ? editData.round_off : 0);
    const [sameAddressCondition, setSameAddressCondition] = useState(editData ? editData.sameAddressCondition : 1);

    const [totalDiscountPer, setTotalDiscountPer] = useState(editData ? editData.totalDiscountPer : 0);
    const [totalDiscountAmt, setTotalDiscountAmt] = useState(editData ? editData.totalDiscountAmt : 0);
    const [assessableAmt, setAssessableAmt] = useState(editData ? editData.assessableAmt : 0);
    const [packing_forwarding, setPacking_forwarding] = useState(editData ? editData.packing_forwarding : 0);
    const [freight_charges, setFreight_charges] = useState(editData ? editData.freight_charges : 0);
    const [tempo_charges, setTempo_charges] = useState(editData ? editData.tempo_charges : 0);
    const [other_charges, setOther_charges] = useState(editData ? editData.other_charges : 0);
    const [discount_show, setDiscount_show] = useState(editData ? editData.discount_show : 0);
    const [packing_forwarding_show, setPacking_forwarding_show] = useState(editData ? editData.packing_forwarding_show : 0);
    const [freight_charges_show, setFreight_charges_show] = useState(editData ? editData.freight_charges_show : 0);
    const [tempo_charges_show, setTempo_charges_show] = useState(editData ? editData.tempo_charges_show : 0);
    const [other_charges_show, setOther_charges_show] = useState(editData ? editData.other_charges_show : 0);
    const [state, setState] = useState(null);
    const [custDetails, setCustDetails] = useState({});

    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.saleInvoice.message);
    const [suggestions, setSuggestions] = useState(Array(inputFields && inputFields.length).fill([])); // Initialize suggestions as an array of empty arrays
    const [selectedItemIndex, setSelectedItemIndex] = useState(-1);


    const [data, setData] = useState({
        id: editid,
        challanNo: editData ? editData.challanNo : '',
        invoiceType: editData ? editData.invoiceType : 'SALE',
        eWayBillNo: editData ? editData.eWayBillNo : '',
        asnNo: editData ? editData.asnNo : '',
        modeOfTransport: editData ? editData.modeOfTransport : '',
        vehicleNo: editData ? editData.vehicleNo : '',
        paymentTerms: editData ? editData.paymentTerms : 30,
        contactPerson: editData ? editData.contactPerson : '',
        contactNo: editData ? editData.contactNo : '',
        basicTotal: editData ? editData.basicTotal : 0,
        gstTotal: editData ? editData.gstTotal : 0,
        total: editData ? editData.total : 0,
        remark: editData ? editData.remark : '',
        orderRefNo: editData ? editData.orderRefNo : '',
        accountManagerName: editData ? editData.accountManagerName : '',
    });

    const [inputFields, setInputFields] = useState(
        editData ? JSON.parse(editData.childRows) :
            [{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: 0,
                unit: null,
                rate: '',
                gst: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
                cgstAmount: 0,
                sgstAmount: 0,
                igstAmount: 0,
                basicAmount: 0,
                amount: 0,
                noOfPkg: '',
                batchNo: '',
                discountPer: 0,
                discountAmt: 0,
            },
            ]);

    const supplierGetData = () => {
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Customer' }));
    }
    const unitGetData = () => {
        dispatch(getUnitList({ companyId: userInfo.companyId }));
    }
    const itemGetData = () => {
        dispatch(getItemList({ companyId: userInfo.companyId }));
    }

    useEffect(() => {
        dispatch(getStateList())
        supplierGetData()
        itemGetData()
        unitGetData()

        if (editData) {
            // setSameAddressCondition(editData.sameAddressCondition)

            const shipping = JSON.parse(editData.shipAddress)
            setShipAddress({
                contact_no: shipping.contact_no,
                address: shipping.address,
                city: shipping.city,
                pinCode: shipping.pinCode,
                contact_person: shipping.contact_person,
                gstn: shipping.gstn,
                party: shipping.party,
                state: shipping.state,
            })

            setState({ name: shipping.state })

            const billing = JSON.parse(editData.billAddress)
            setBillAddress({
                contact_no: billing.contact_no,
                address: billing.address,
                city: billing.city,
                pinCode: billing.pinCode,
                contact_person: billing.contact_person,
                gstn: billing.gstn,
                party: billing.party,
                state: billing.state,
            })
            setCustomerName({
                CNS_Name: editData.CNS_Name,
                CSNId: editData.customerName,
                emailId: editData.emailId,
                gstn: editData.gstn,
                address: editData.address,
                city: editData.city,
                pinCode: editData.pinCode,
                contact_person: editData.contact_person,
                state: editData.state,
                party: editData.CNS_Name,
                contact_no: editData.contact_no,
            })

            const newArr = []
            JSON.parse(editData.childRows).map((row) => (
                newArr.push({
                    itemId: row,
                    itemCode: row.itemCode,
                    // itemId: row.itemId,
                    itemName: row.itemName,
                    itemDescription: row.itemDescription,
                    hsnCode: row.hsnCode,
                    quantity: row.quantity,
                    unit: row,
                    rate: row.rate,
                    gst: row.gst,
                    cgst: row.cgst,
                    sgst: row.sgst,
                    igst: row.igst,
                    gstAmount: row.gstAmount,
                    cgstAmount: row.cgstAmount,
                    sgstAmount: row.sgstAmount,
                    igstAmount: row.igstAmount,
                    basicAmount: row.basicAmount,
                    amount: row.amount,
                    noOfPkg: row.noOfPkg,
                    batchNo: row.batchNo,
                    discountPer: row.discountPer,
                    discountAmt: row.discountAmt,
                })
            ))

            setInputFields(newArr)
        }
    }, [])

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Sales Invoice already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    useEffect(() => {
    }, [termsList, availTermsList])

    useEffect(() => {
        const initialInputFields = termsList && termsList.map((r, index) => ({
            id: uuidv4(),
            termsAndConditions: r.termsAndConditions,
            trueFalse: editid === null ? true : availTermsList.find((n) => n.termsAndConditions === r.termsAndConditions)?.trueFalse || false,
        }));
        setRowsTerms(initialInputFields);
    }, [])

    const handleChangeInvoiceDate = (newValue) => {
        setInvoiceDate(newValue);
    };

    const handleChangeChallanDate = (newValue) => {
        setChallanDate(newValue);
    };

    const handleChangePoDate = (newValue) => {
        setOrderRefDate(newValue);
    };

    const handleChangeDiscount_show = ({ target }) => {
        let value = target.checked;
        setDiscount_show(value == true ? 1 : 0);
    }
    const handleChangePacking_forwarding_show = ({ target }) => {
        let value = target.checked;
        setPacking_forwarding_show(value == true ? 1 : 0);
    }
    const handleChangeFreight_charges_show = ({ target }) => {
        let value = target.checked;
        setFreight_charges_show(value == true ? 1 : 0);
    }
    const handleChangeTempo_charges_show = ({ target }) => {
        let value = target.checked;
        setTempo_charges_show(value == true ? 1 : 0);
    }
    const handleChangeOther_charges_show = ({ target }) => {
        let value = target.checked;
        setOther_charges_show(value == true ? 1 : 0);
    }

    const handleChangeState = (event, newValue) => {
        setState(newValue)
        setShipAddress({
            contact_no: shipAddress == null ? null : shipAddress?.contact_no,
            address: shipAddress == null ? null : shipAddress?.address,
            city: shipAddress == null ? null : shipAddress?.city,
            pinCode: shipAddress == null ? null : shipAddress?.pinCode,
            contact_person: shipAddress == null ? null : shipAddress?.contact_person,
            gstn: shipAddress == null ? null : shipAddress?.gstn,
            party: shipAddress == null ? null : shipAddress?.party,
            state: newValue == null ? null : newValue?.name,
        })
    }

    const handleChangeTerms = (event, index) => {
        const updatedFields = [...rowsTerms];
        updatedFields[index].trueFalse = event.target.checked;
        setRowsTerms(updatedFields);
        setIsUpdateArray(isUpdateArray ? false : true);
    };

    const handleChangeCheckbox = ({ target }) => {
        let value = target.checked;
        setSameAddressCondition(value == true ? 1 : 0);
        if (target.checked === true) {
            setShipAddress({
                contact_no: customerName.mobileNo,
                address: customerName.address,
                city: customerName.city,
                pinCode: customerName.pinCode,
                contact_person: customerName.contactPerson,
                gstn: customerName.gstn,
                party: customerName.CNS_Name,
                state: customerName.state,
            })
            setBillAddress({
                contact_no: customerName.mobileNo,
                address: customerName.address,
                city: customerName.city,
                pinCode: customerName.pinCode,
                contact_person: customerName.contactPerson,
                gstn: customerName.gstn,
                party: customerName.CNS_Name,
                state: customerName.state,
            })
        } else {
            if (editData) {
                const shipping = JSON.parse(editData.shipAddress)
                setShipAddress({
                    contact_no: editData ? shipping.contact_no : '',
                    address: editData ? shipping.address : '',
                    city: editData ? shipping.city : '',
                    pinCode: editData ? shipping.pinCode : '',
                    contact_person: editData ? shipping.contact_person : '',
                    gstn: editData ? shipping.gstn : '',
                    party: editData ? shipping.party : '',
                    state: editData ? shipping.state : '',
                })
            } else {
                setShipAddress({
                    contact_no: '',
                    address: '',
                    city: '',
                    pinCode: '',
                    contact_person: '',
                    gstn: '',
                    party: '',
                    state: state?.name,
                })
            }
            setBillAddress({
                contact_no: customerName.mobileNo,
                address: customerName.address,
                city: customerName.city,
                pinCode: customerName.pinCode,
                contact_person: customerName.contactPerson,
                gstn: customerName.gstn,
                party: customerName.CNS_Name,
                state: customerName.state,
            })
        }
    }

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
        setIsSet(isSet ? false : true)
    }

    const handleChangeAddr = ({ target }) => {
        const value = target.value;
        setShipAddress({
            ...shipAddress,
            [target.name]: value,
        });
        shipAddress[target.name] = target.value;

        setIsSet(isSet ? false : true)
    }

    const handleSuggestionClick = (suggestion, index) => {
        setInputFields((prevInputFields) => {
            const updatedFields = [...prevInputFields];
            updatedFields[index] = {
                ...updatedFields[index],
                itemDescription: suggestion,
                suggestions: [], // Clear suggestions
                selectedItemIndex: -1, // Reset selectedItemIndex
            }
            return updatedFields;
        });
        setIsUpdateArray(!isUpdateArray);
        setSuggestions([]);
        setSelectedItemIndex(-1);
    };

    const handleChangeUnit = (index) => (event, newValue) => {
        setInputFields((prevInputFields) => {
            const updatedFields = [...prevInputFields];
            updatedFields[index].unit = newValue;
            return updatedFields;
        })
    }

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            {
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: 0,
                unit: null,
                rate: '',
                gst: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
                cgstAmount: 0,
                sgstAmount: 0,
                igstAmount: 0,
                basicAmount: 0,
                amount: 0,
                noOfPkg: '',
                batchNo: '',
                discountPer: 0,
                discountAmt: 0,
            },
        ]);
    };

    const navigateToAddEdit = (row) => {
        const state = {
            CNS_Type: 'Customer',
            availCNS_Type: true,
        };
        navigate('/masters/add-party-masters', { state });
    };

    // ================================================================
    const handleCalculation = (rate, qty, discountPer) => {
        let Amt1 = parseFloat(qty) * parseFloat(rate);
        let discountAmt = (Amt1 * parseFloat(discountPer)) / 100;
        let amt = Amt1 - discountAmt;

        const basicAmt = amt - discountAmt;
        const totalDiscountAmt1 = (basicAmt * parseFloat(totalDiscountPer)) / 100
        const assessAmt1 = basicAmt - totalDiscountAmt1;
        const assessableAmt1 = parseFloat(assessAmt1) + parseFloat(packing_forwarding) + parseFloat(freight_charges) + parseFloat(tempo_charges) + parseFloat(other_charges)
        const gstAmt = (assessableAmt1 * parseFloat(gst)) / 100;
        const totalAmt = parseFloat(assessableAmt1) + parseFloat(gstAmt);

        const cgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(gst));

        const cgstAmt = (assessableAmt1 * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assessableAmt1 * parseFloat(sgstPer)) / 100;
        const igstAmt = (assessableAmt1 * parseFloat(igstPer)) / 100;

        setCgst(cgstPer);
        setSgst(sgstPer);
        setIgst(igstPer);

        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);

        setGstTotal(gstAmt);
        setTotalDiscountAmt(totalDiscountAmt1);
        setAssessableAmt(assessableAmt1);
        setTotal(totalAmt);
        const roundedValue = Math.round(totalAmt);
        setRound_off(roundedValue - totalAmt);

        return {
            rate: parseFloat(rate),
            quantity: parseFloat(qty),
            gst: parseFloat(gst),
            basicAmount: basicAmt,
            gstAmount: gstAmt,
            amount: amt,
            cgst: cgstPer,
            sgst: sgstPer,
            igst: igstPer,
            cgstAmount: cgstAmt,
            sgstAmount: sgstAmt,
            igstAmount: igstAmt,
            discountPer: discountPer,
            discountAmt: discountAmt,
        };
    }
    const handleAllCalculation = (TotalDisc, PkgForwd, Freight, Tempo, Other, GstPr) => {
        let basicAmt = parseFloat(basicTotal);
        const totalDiscountAmt1 = (basicAmt * parseFloat(TotalDisc)) / 100;
        const assessAmt1 = basicAmt - totalDiscountAmt1;
        const assessableAmt1 = parseFloat(assessAmt1) + parseFloat(PkgForwd) + parseFloat(Freight) + parseFloat(Tempo) + parseFloat(Other)
        const gstAmt = (assessableAmt1 * parseFloat(GstPr)) / 100;
        const totalAmt = parseFloat(assessableAmt1) + parseFloat(gstAmt);
    
        const cgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(GstPr)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(GstPr)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(GstPr));
    
        const cgstAmt = (assessableAmt1 * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assessableAmt1 * parseFloat(sgstPer)) / 100;
        const igstAmt = (assessableAmt1 * parseFloat(igstPer)) / 100;
    
        setCgst(cgstPer);
        setSgst(sgstPer);
        setIgst(igstPer);
    
        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);
    
        setGstTotal(gstAmt);
        setTotalDiscountAmt(totalDiscountAmt1);
        setAssessableAmt(assessableAmt1);
        setTotal(totalAmt);
        const roundedValue = Math.round(totalAmt);
        setRound_off(roundedValue - totalAmt);
    }
    
    // ===============================================================

    const handleChangeCustomer = (event, newValue) => {
        setCustDetails({
            creditLimit: newValue?.creditLimit,
            creditPeriod: newValue?.creditPeriod,
            totalReceivable: newValue?.totalReceivable,
        })
        setSameAddressCondition(1);
        setCustomerName(newValue)
        setBillAddress({
            contact_no: newValue == null ? null : newValue.mobileNo,
            address: newValue == null ? null : newValue.address,
            city: newValue == null ? null : newValue.city,
            pinCode: newValue == null ? null : newValue.pinCode,
            contact_person: newValue == null ? null : newValue.contactPerson,
            gstn: newValue == null ? null : newValue.gstn,
            party: newValue == null ? null : newValue.CNS_Name,
            state: newValue == null ? null : newValue.state,
        })
        setShipAddress({
            contact_no: newValue == null ? null : newValue.mobileNo,
            address: newValue == null ? null : newValue.address,
            city: newValue == null ? null : newValue.city,
            pinCode: newValue == null ? null : newValue.pinCode,
            contact_person: newValue == null ? null : newValue.contactPerson,
            gstn: newValue == null ? null : newValue.gstn,
            party: newValue == null ? null : newValue.CNS_Name,
            state: newValue == null ? null : newValue?.state,
        })

        dispatch(getSalesItemDescriptionForManualEntry({ companyId: userInfo.companyId, customerName: newValue == null ? null : newValue.CSNId }))

        dispatch(getAgeOfUnpaidInvoice({ companyId: userInfo.companyId, customerName: newValue == null ? null : newValue.CSNId }))

        const cgstPer = (convertStringIntoTitleCase(newValue == null ? null : newValue.city) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(newValue == null ? null : newValue.city) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(newValue == null ? null : newValue.city) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(gst));

        const cgstAmt = (assessableAmt * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assessableAmt * parseFloat(sgstPer)) / 100;
        const igstAmt = (assessableAmt * parseFloat(igstPer)) / 100;

        setCgst(cgstPer);
        setSgst(sgstPer);
        setIgst(igstPer);

        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);
    }

    const handleRemoveFields = (id) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setInputFields(values);

        setIsUpdateArray(isUpdateArray ? false : true);

        const reducer = (previousValue, currentValue) => previousValue + currentValue;
        const amount1 = values && values.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);

        let basicAmt = parseFloat(amount1);

        const totalDiscountAmt1 = (basicAmt * parseFloat(totalDiscountPer)) / 100;
        const assessAmt = basicAmt - totalDiscountAmt1;

        const assessableAmt1 = parseFloat(assessAmt) + parseFloat(packing_forwarding) + parseFloat(freight_charges) + parseFloat(tempo_charges) + parseFloat(other_charges)

        const gstAmt = (assessableAmt1 * parseFloat(gst)) / 100;

        const cgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(gst));

        const cgstAmt = (assessableAmt1 * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assessableAmt1 * parseFloat(sgstPer)) / 100;
        const igstAmt = (assessableAmt1 * parseFloat(igstPer)) / 100;

        const totalAmt = parseFloat(assessableAmt1) + parseFloat(gstAmt);
        setCgst(cgstPer);
        setSgst(sgstPer);
        setIgst(igstPer);

        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);

        setGstTotal(gstAmt);
        setBasicTotal(basicAmt);
        setTotalDiscountAmt(totalDiscountAmt1);
        setAssessableAmt(assessableAmt1);
        setTotal(totalAmt);
        const roundedValue = Math.round(totalAmt);
        setRound_off(roundedValue - totalAmt);
        setIsSet(isSet ? false : true)
    };

    const handleChangeItemDescriptionMN = (index) => (e) => {
        const newValue = e.target.value;
        setInputFields((prevInputFields) => {

            const updatedFields = [...prevInputFields];

            updatedFields[index].itemDescription = newValue;

            handleCalculation(
                updatedFields[index]?.rate || 0,
                updatedFields[index]?.quantity || 0,
                updatedFields[index]?.discountPer || 0
            );

            const inputText = newValue.toLowerCase();

            let filteredSuggestions = sales_itemDescription_forManualEntryList.filter((item) =>
                item.itemDescription && item.itemDescription.toLowerCase().includes(inputText)
            );

            // setSuggestions(filteredSuggestions, index);
            // setSelectedItemIndex(-1);

            updatedFields[index].suggestions = filteredSuggestions

            return updatedFields;

        });

        // const reducer = (previousValue, currentValue) => previousValue + currentValue;

        // const totalCount = inputFields && inputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);
        // setBasicTotal(totalCount);

        // let gstamount = parseFloat((totalCount * parseFloat(gst === undefined ? 0 : gst)) / 100);
        // // let totalamount = totalCount + gstamount + parseFloat(igstTotal) + parseFloat(sgstTotal) + parseFloat(cgstTotal);
        // let totalamount = totalCount + gstamount;
        // setGstTotal(gstamount);
        // setTotal(totalamount);
        // setIsSet(isSet ? false : true)

    };

    const handleChangeItemDescription = (index) => (event, newValue) => {

        const updatedInputFields = inputFields.map((row, ind) => {

            if (ind === index) {
                const calculatedValues = handleCalculation(
                    newValue?.rate || 0,
                    parseFloat(row.quantity),
                    parseFloat(row.discountPer) || 0
                );

                return {
                    ...row,
                    itemId: invoiceSetting.itemThroughManualEntry === 'true' ? null : newValue,
                    itemDescription: invoiceSetting.itemThroughManualEntry === 'true' ? newValue === null ? null : newValue.itemDescription : null,
                    itemCode: invoiceSetting.itemThroughManualEntry === 'true' ? null : newValue === null ? null : newValue.itemCode,
                    itemName: invoiceSetting.itemThroughManualEntry === 'true' ? null : newValue === null ? null : newValue.itemName,
                    hsnCode: newValue === null ? null : newValue.hsnCode,
                    unit: newValue === null ? null : newValue,
                    ...calculatedValues,
                    noOfPkg: '',
                    batchNo: '',
                };
            }
            return row;
        });

        setInputFields(updatedInputFields);
        setIsUpdateArray(!isUpdateArray);

        // const reducer = (previousValue, currentValue) => previousValue + currentValue;

        // const totalCount = updatedInputFields && updatedInputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);
        // let gstamount = parseFloat((totalCount * parseFloat(gst === undefined ? 0 : gst)) / 100);
        // // let totalamount = totalCount + gstamount + parseFloat(igstTotal) + parseFloat(sgstTotal) + parseFloat(cgstTotal);
        // let totalamount = totalCount + gstamount;
        // setBasicTotal(totalCount);
        // setGstTotal(gstamount);
        // setTotal(totalamount);
        // setIsSet(isSet ? false : true)
    };

    const handleMultipleInput = (e, i) => {
        const array = inputFields;
        let result = array[i];

        result[e.target.name] = e.target.value;
        array[i] = result;

        setInputFields(array);
        setIsUpdateArray(isUpdateArray ? false : true);

        let tltAmt = result['amount'] ? result['amount'] : 0;
        let qty = result['quantity'] ? result['quantity'] : 0;
        let rate = result['rate'] ? result['rate'] : 0;
        let discountPer = result['discountPer'] ? result['discountPer'] : 0;

        if (e.target.name == 'quantity') {
            qty = parseFloat(e.target.value);
            // handleCalculation(
            //     parseFloat(result['rate']),
            //     parseFloat(qty),
            //     parseFloat(result['discountPer'])
            // );
        }

        if (e.target.name == 'rate') {
            rate = parseFloat(e.target.value);
            // handleCalculation(
            //     parseFloat(rate),
            //     parseFloat(result['quantity']),
            //     parseFloat(result['discountPer'])
            // );
        }

        if (e.target.name == 'discountPer') {
            discountPer = parseFloat(e.target.value);
            // handleCalculation(
            //     parseFloat(result['rate']),
            //     parseFloat(result['quantity']),
            //     parseFloat(discountPer)
            // );

        }


        let Amt1 = parseFloat(qty) * parseFloat(rate);
        let discountAmt = (Amt1 * parseFloat(discountPer)) / 100;

        const basicAmt = Amt1 - discountAmt;
        
        const totalDiscountAmt1 = (basicAmt * parseFloat(totalDiscountPer)) / 100;
        const assessAmt1 = basicAmt - totalDiscountAmt1;
        const assessableAmt1 = parseFloat(assessAmt1) + parseFloat(packing_forwarding) + parseFloat(freight_charges) + parseFloat(tempo_charges) + parseFloat(other_charges);

        const gstAmt = (assessableAmt1 * parseFloat(gst)) / 100;
        const totalAmt = parseFloat(assessableAmt1) + parseFloat(gstAmt);

        result['basicAmount'] = parseFloat(basicAmt);
        result['discountAmt'] = parseFloat(discountAmt);
        result['gstAmount'] = parseFloat(gstAmt);
        // result['amount'] = parseFloat(tltAmt);
        result['amount'] = parseFloat(basicAmt);

        array[i] = result;

        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        const bsAmt = inputFields && inputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);
        const tltDSAmt = (bsAmt * totalDiscountPer) / 100
        const assAmtFinal = bsAmt - tltDSAmt;
        const assAmt = parseFloat(assAmtFinal) + parseFloat(packing_forwarding) + parseFloat(freight_charges) + parseFloat(tempo_charges) + parseFloat(other_charges)
        const cgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(customerName.state) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(gst));

        const cgstAmt = (assAmt * parseFloat(cgstPer)) / 100;
        const sgstAmt = (assAmt * parseFloat(sgstPer)) / 100;
        const igstAmt = (assAmt * parseFloat(igstPer)) / 100;

        result['cgstAmount'] = parseFloat(cgstAmt);
        result['sgstAmount'] = parseFloat(sgstAmt);
        result['igstAmount'] = parseFloat(igstAmt);

        setCgst(cgstPer);
        setSgst(sgstPer);
        setIgst(igstPer);

        setCgstTotal(cgstAmt);
        setSgstTotal(sgstAmt);
        setIgstTotal(igstAmt);

        let gstamount = parseFloat((assAmt * parseFloat(gst === undefined ? 0 : gst)) / 100);
        let grandTltAmount = parseFloat(assAmt) + parseFloat(gstamount);

        setBasicTotal(bsAmt);
        setTotalDiscountAmt(tltDSAmt);
        setAssessableAmt(assAmt);
        setGstTotal(gstamount);
        setTotal(grandTltAmount);
        const roundedValue = Math.round(grandTltAmount);
        setRound_off(roundedValue - grandTltAmount);

        setIsSet(isSet ? false : true)

    };

    const handleChangeGST = (e) => {
        setGSt(e.target.value);
        handleAllCalculation(totalDiscountPer, packing_forwarding, freight_charges, tempo_charges, other_charges, e.target.value)
    }
    
    const handleChangeTotalDiscountPer = (e) => {
        setTotalDiscountPer(e.target.value);
        handleAllCalculation(e.target.value, packing_forwarding, freight_charges, tempo_charges, other_charges, gst)
    }
    
    const handleChangePackingForwarding = (e) => {
        setPacking_forwarding(e.target.value);
        handleAllCalculation(totalDiscountPer, e.target.value, freight_charges, tempo_charges, other_charges, gst)
    }
    
    const handleChangeFreightCharges = (e) => {
        setFreight_charges(e.target.value);
        handleAllCalculation(totalDiscountPer, packing_forwarding, e.target.value, tempo_charges, other_charges, gst)
    }
    
    const handleChangeTempoCharges = (e) => {
        setTempo_charges(e.target.value);
        handleAllCalculation(totalDiscountPer, packing_forwarding, freight_charges, e.target.value, other_charges, gst)
    }
    
    const handleChangeOtherCharges = (e) => {
        setOther_charges(e.target.value);
        handleAllCalculation(totalDiscountPer, packing_forwarding, freight_charges, tempo_charges, e.target.value, gst)
    }
    // ================================================================
    const onSubmit = (event) => {


        // // let TermsLength = rowsTerms.filter((n) => n.trueFalse === true)
        // // if (TermsLength.length === 0) {
        // //     alert("Please select at least one TERMS & CONDITIONS to create invoice!")
        //  // } else {
        if (docNoFormateAvailable && docNoFormateAvailable.length === 0) {
            alert("Please enter Document No Format")
        } else {
            let saleInvoiceData = {
                ...data,
                invoiceDate: dateConversionOnEntryPage(invoiceDate),
                challanDate: dateConversionOnEntryPage(challanDate),
                orderRefDate: dateConversionOnEntryPage(orderRefDate),
                childRows: inputFields,
                gst: gst,
                basicTotal: basicTotal,
                gstTotal: gstTotal,
                cgst: cgst,
                sgst: sgst,
                igst: igst,
                cgstTotal: cgstTotal,
                sgstTotal: sgstTotal,
                igstTotal: igstTotal,
                total: total,
                round_off: round_off,
                pendingAmount: total,
                totalDiscountPer: totalDiscountPer,
                totalDiscountAmt: totalDiscountAmt,
                assessableAmt: assessableAmt,
                packing_forwarding: packing_forwarding,
                freight_charges: freight_charges,
                tempo_charges: tempo_charges,
                other_charges: other_charges,
                discount_show: discount_show,
                packing_forwarding_show: packing_forwarding_show,
                freight_charges_show: freight_charges_show,
                tempo_charges_show: tempo_charges_show,
                other_charges_show: other_charges_show,
                companyId: userInfo.companyId,
                customerName: customerName.CSNId,
                billAddress: billAddress,
                shipAddress: shipAddress,
                sameAddressCondition: sameAddressCondition,
                rowsTerms: rowsTerms,
                finYear: editData ? editData.finYear : financialYear(userInfo.financialYear, invoiceDate.$M, invoiceDate.$y),
                createdBy: editData ? editData.createdBy : userInfo.userId,
                createdAt: editData ? editData.createdAt : dateConversionOnEntryPageWithTime(new Date()),
                modifiedBy: editData ? userInfo.userId : null,
                modifiedAt: editData ? dateConversionOnEntryPageWithTime(new Date()) : '',
                changedUpdatedValue: 'edit'
            }

            if (editData) {
                dispatch(editDeleteSaleInvoice(saleInvoiceData));
            } else {
                if (custDetails.creditLimit > 0 && parseFloat(custDetails.creditLimit) <= (parseFloat(custDetails.totalReceivable) + parseFloat(total))) {
                    alert(`Amount is exceeding credit limit of amount ${custDetails.creditLimit}. Invoice can not be generated.`)
                } else if (custDetails.creditPeriod > 0 && ageOfUnpaidInvoiceList.length > 0) {
                    const compareValue = 'ageOfUnpaidInvoice';
                    const largestAge = ageOfUnpaidInvoiceList && ageOfUnpaidInvoiceList.reduce((max, obj) => (obj[compareValue] > max[compareValue] ? obj : max), ageOfUnpaidInvoiceList[0]);

                    if (largestAge?.ageOfUnpaidInvoice >= custDetails.creditPeriod) {
                        alert(`Overdue invoice/s is/are older than credit period ${custDetails.creditPeriod}. Invoice can not be generated.`)
                    } else {
                        dispatch(addSaleInvoice(saleInvoiceData));
                    }
                } else {
                    dispatch(addSaleInvoice(saleInvoiceData));
                }
            }
        }

    }

    return (
        <>
            <div>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Sales', path: '/sales/' },
                        { name: 'Sales Invoice List', path: '/sales/sales-invoice' },
                        { name: 'Create Sales Invoice' },
                    ]}
                />
                <Paper className={`${styles.list_container}`} style={{ paddingLeft: '10px', paddingRight: '10px' }}>

                    {/* <Box >
                        <Grid container spacing={0.2} sx={{ pb: 1 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create Sales Invoice</Typography>
                            </Grid>
                        </Grid>
                    </Box> */}
                    <Box sx={{ m: 2 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box>
                            <Grid container spacing={0} sx={{ p: 0 }}>
                                <Grid item md={6}>
                                    <Box sx={{ display: 'flex' }}>
                                        <Autocomplete sx={{ marginBottom: '10px' }}

                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={customerList}
                                            value={customerName}
                                            onChange={handleChangeCustomer}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Please Select Customer"
                                                sx={{
                                                    width: { sm: 400, md: 400 },
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12,
                                                    }
                                                }} {...params} />}
                                        />
                                        <AddCircleOutlineOutlinedIcon className={`${styles.addBtnEntry}`} onClick={() => navigateToAddEdit()} />
                                    </Box>
                                    {customerName &&
                                        <Card sx={{ maxWidth: 400, backgroundColor: '#f0efed', }}>
                                            <CardContent sx={{ padding: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '15px' }}> {customerName.CNS_Name}</Typography>
                                                {/* <Typography sx={{ fontSize: '11px', }}><Icon icon="arcticons:gstrings" width="14" height="12" style={{ marginRight: '7px' }} /> {customerName.gstn} </Typography> */}
                                                <Typography sx={{ fontSize: '11px' }}> <Icon icon="fa6-regular:address-card" width="12" height="12" style={{ marginRight: '8px' }} /> {customerName.address}</Typography>
                                                <Typography sx={{ fontSize: '11px' }}> {customerName.state + ","} {customerName.pinCode} </Typography>
                                            </CardContent>
                                        </Card>
                                    }
                                    <Grid item xs={12} sx={{ mt: 1 }}>
                                        {customerName &&
                                            <>
                                                <FormControlLabel
                                                    control={<Checkbox size='small'
                                                        // defaultChecked={editData ? editData.sameAddress : false}
                                                        defaultChecked={sameAddressCondition}
                                                        name='sameAddressCondition'
                                                        value={sameAddressCondition}
                                                        onChange={handleChangeCheckbox}
                                                    />}
                                                    label={
                                                        <Typography style={{ fontSize: '12px' }}>
                                                            Shipping address same as billing address
                                                        </Typography>
                                                    }
                                                />

                                                {sameAddressCondition === 0 &&
                                                    <Card sx={{ mt: 0.5, mr: 6 }}>
                                                        <CardContent>
                                                            <Grid container spacing={1} >
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>Party Name</Typography>
                                                                </Grid>
                                                                <Grid item xs={10}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="party"
                                                                        type="text"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.party}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>Address</Typography>
                                                                </Grid>
                                                                <Grid item xs={10}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="address"
                                                                        type="text"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.address}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>City</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="city"
                                                                        type="text"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.city}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>State</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <Autocomplete
                                                                        fullWidth
                                                                        classes={{
                                                                            option: classes.option,
                                                                        }}
                                                                        noOptionsText={
                                                                            <span className={classes.noOptionsLabel}>No options</span>
                                                                        }
                                                                        options={stateList}
                                                                        value={state}
                                                                        onChange={handleChangeState}
                                                                        getOptionLabel={(option) => option.name}
                                                                        getOptionSelected={(option, value) => option.name === value.name}
                                                                        renderInput={(params) => <ERPinput  {...params} />}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>Pincode</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="pinCode"
                                                                        type="number"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.pinCode}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>Contact Person</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="contact_person"
                                                                        type="text"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.contact_person}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>Contact No</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="contact_no"
                                                                        type="number"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.contact_no}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <Typography className={`${styles.erp_lable}`}>GSTIN</Typography>
                                                                </Grid>
                                                                <Grid item xs={4}>
                                                                    <ERPinput
                                                                        size='small'
                                                                        fullWidth
                                                                        name="gstn"
                                                                        type="text"
                                                                        onChange={handleChangeAddr}
                                                                        value={shipAddress.gstn}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </CardContent>
                                                    </Card>
                                                }
                                            </>

                                        }
                                    </Grid>
                                </Grid>
                                <Grid item md={6}>
                                    <Box >

                                        <Grid container spacing={1} >
                                            {!editData &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`} sx={{ fontWeight: 'bold', color: '#0000cc' }}> Last Invoice No</Typography>
                                                    </Grid>
                                                    <Grid item xs={10}>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#0000cc' }} >{lastEntryNo}</Typography>
                                                    </Grid>
                                                </>
                                            }
                                            {editData ?
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Invoice No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            disabled={true}
                                                            size='small'
                                                            fullWidth
                                                            name="invoiceNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={editData.invoiceNo}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Invoice No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={`${styles.skeleton_text}`}>
                                                            <Typography style={{ fontSize: '12px', padding: '1px 4px 1px 10px', color: '#707070' }}></Typography>
                                                        </div>
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}> Invoice Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="invoiceDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={invoiceDate}
                                                        onChange={handleChangeInvoiceDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Challan No</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="challanNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.challanNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Challan Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="challanDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={challanDate}
                                                        onChange={handleChangeChallanDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>PO No</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="orderRefNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.orderRefNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>PO. Date </Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="orderRefDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={orderRefDate}
                                                        onChange={handleChangePoDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'

                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            {invoiceSetting.showEWayBillNo === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>E-Way Bill No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="eWayBillNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.eWayBillNo)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showTransportMode === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>LR No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="modeOfTransport"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.modeOfTransport)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showVehicleNo === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Vehicle No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="vehicleNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.vehicleNo)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showPaymentTerms === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Payment Terms (days)</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinputNo
                                                            size='small'
                                                            fullWidth
                                                            name="paymentTerms"
                                                            type="number"
                                                            onChange={handleChange}
                                                            value={(data.paymentTerms)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showAccountName === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Account Name</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="accountManagerName"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.accountManagerName)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                            {invoiceSetting.showContactPerson === 'true' &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Contact Person</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="contactPerson"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={(data.contactPerson)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            }
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <br />
                        <TableContainer sx={{ overflowY: 'auto', minHeight: 140, maxHeight: 220 }}>
                            <Table sx={{ minWidth: 700, }} size='small' stickyHeader>
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell align="left" className={`${styles.table_head}`} width="50%">
                                            Description of Goods
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>HSN Code</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Unit Price</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Quantity</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>Unit</StyledTableCell>
                                        {invoiceSetting.showDiscountPer_details === 'true' &&
                                            <>
                                                <StyledTableCell align="right" className={`${styles.table_head}`}>Discount %</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`}>Discount Amt</StyledTableCell>
                                            </>
                                        }
                                        {invoiceSetting.showNoOfPKG === 'true' &&
                                            <StyledTableCell align="right" className={`${styles.table_head}`}>No of PKG</StyledTableCell>
                                        }
                                        {invoiceSetting.showBatchNo === 'true' &&
                                            <StyledTableCell align="left" className={`${styles.table_head}`}>Batch No</StyledTableCell>
                                        }
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Amount</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Action</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(inputFields) && inputFields.map((row, index) => (
                                        <>
                                            {customerName &&
                                                <StyledTableRow key={row.itemId} >
                                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                        {invoiceSetting.itemThroughManualEntry === 'true' ?
                                                            <Box key={index} style={{ position: 'relative' }}>
                                                                <ERPinput
                                                                    variant="standard"
                                                                    fullWidth
                                                                    type="text"
                                                                    value={row.itemDescription}
                                                                    InputProps={{
                                                                        required: invoiceSetting.itemThroughManualEntry === 'true' ? true : false,
                                                                    }}
                                                                    onChange={handleChangeItemDescriptionMN(index)}
                                                                />
                                                                <div style={{ position: 'absolute', top: '30px', left: '0' }}>
                                                                    {row.suggestions?.map((suggestion, i) => (
                                                                        <MenuItem
                                                                            key={i}
                                                                            className={`${styles.erp_lable}`}
                                                                            onClick={() => handleSuggestionClick(suggestion.itemDescription, index)}
                                                                        >
                                                                            {suggestion.itemDescription}
                                                                        </MenuItem>
                                                                    ))}
                                                                </div>
                                                            </Box>
                                                            :
                                                            <Autocomplete

                                                                fullWidth
                                                                classes={{
                                                                    option: classes.option,
                                                                    // paper: classes.autocompletePaper,
                                                                }}

                                                                noOptionsText={
                                                                    <span className={classes.noOptionsLabel}>No options</span>
                                                                }
                                                                options={itemList}
                                                                value={row.itemId}
                                                                onChange={handleChangeItemDescription(index)}
                                                                getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                                                getOptionSelected={(option, value) => option.id === value.id}
                                                                renderInput={(params) => <ERPinput variant="standard"
                                                                    InputProps={{
                                                                        required: invoiceSetting.itemThroughManualEntry === 'true' ? false : true,
                                                                        disableUnderline: true,
                                                                    }}
                                                                    {...params} />}
                                                            />
                                                        }
                                                    </StyledTableCell>
                                                    <StyledTableCell className={`${styles.list_table_body}`}>
                                                        <ERPinput
                                                            variant="standard"
                                                            required
                                                            type="text"
                                                            name="hsnCode"
                                                            value={row.hsnCode}
                                                            size='small'
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                readOnly: invoiceSetting.itemThroughManualEntry === 'true' ? false : true,
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="rate"
                                                            value={row.rate}
                                                            size='small'
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>

                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="quantity"
                                                            value={row.quantity}
                                                            size='small'
                                                            // onChange={(e) => handleChangeTable(e, index)}
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>

                                                    <StyledTableCell className={`${styles.list_table_body}`}>
                                                        <Autocomplete
                                                            fullWidth
                                                            classes={{
                                                                option: classes.option,
                                                            }}
                                                            noOptionsText={
                                                                <span className={classes.noOptionsLabel}>No options</span>
                                                            }
                                                            options={unitList}
                                                            value={row.unit}
                                                            onChange={handleChangeUnit(index)}
                                                            getOptionLabel={(option) => option.unit}
                                                            getOptionSelected={(option, value) => option.unit === value.unit}
                                                            renderInput={(params) => <ERPinput required variant="standard"
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                {...params} />}
                                                        />
                                                    </StyledTableCell>

                                                    {invoiceSetting.showDiscountPer_details === 'true' &&
                                                        <>
                                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                                <ERPinputNo
                                                                    variant="standard"
                                                                    type="number"
                                                                    name="discountPer"
                                                                    value={row.discountPer}
                                                                    size='small'
                                                                    onChange={(e) => handleMultipleInput(e, index)}

                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                    }}
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                                <ERPinputNo
                                                                    variant="standard"
                                                                    type="number"
                                                                    name="discountPer"
                                                                    value={row.discountAmt}
                                                                    size='small'
                                                                    onChange={(e) => handleMultipleInput(e, index)}

                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                    }}
                                                                />
                                                            </StyledTableCell>
                                                        </>
                                                    }

                                                    {invoiceSetting.showNoOfPKG === 'true' &&
                                                        <StyledTableCell className={`${styles.list_table_body}`}>
                                                            <ERPinputNo
                                                                variant="standard"
                                                                type="number"
                                                                name="noOfPkg"
                                                                value={row.noOfPkg}
                                                                size='small'
                                                                // onChange={(e) => handleChangeTable(e, index)}
                                                                onChange={(e) => handleMultipleInput(e, index)}
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                            />
                                                        </StyledTableCell>
                                                    }
                                                    {invoiceSetting.showBatchNo === 'true' &&
                                                        <StyledTableCell className={`${styles.list_table_body}`}>
                                                            <ERPinput
                                                                variant="standard"
                                                                type="text"
                                                                name="batchNo"
                                                                value={row.batchNo}
                                                                size='small'
                                                                onChange={(e) => handleMultipleInput(e, index)}

                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                            />
                                                        </StyledTableCell>
                                                    }
                                                    <StyledTableCell className={`${styles.list_table_body}`} align='right'>
                                                        <ERPinputNo
                                                            variant="standard"
                                                            required
                                                            type="number"
                                                            name="amount"
                                                            value={parseFloat(row.amount).toFixed(2)}
                                                            size='small'
                                                            // onChange={(e) => handleChangeTable(e, index)}
                                                            onChange={(e) => handleMultipleInput(e, index)}
                                                            InputProps={{
                                                                readOnly: true,
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`} >
                                                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <IconButton size="small" style={{ color: 'blue', fontSize: '14px' }} onClick={handleAddFields}>
                                                                <Icon icon="line-md:plus" />
                                                            </IconButton>
                                                            {index === 0 ?
                                                                <IconButton disabled size="small" sx={{ fontSize: '12px', color: 'red' }} >
                                                                    <Icon icon={'line-md:remove'} />
                                                                </IconButton> :
                                                                <IconButton size="small" onClick={() => handleRemoveFields(row.id)} sx={{ fontSize: '12px', color: 'red' }}>
                                                                    <Icon icon={'line-md:remove'} />
                                                                </IconButton>}
                                                        </Box>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box >
                            <Grid container spacing={0} sx={{ mt: 1, }}>
                                <Grid item xs={6}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography className={`${styles.erp_lable}`} sx={{ marginBottom: '8px' }}> Remarks</Typography>
                                            <ERPinput
                                                sx={{
                                                    width: { sm: 100, md: 400 },
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12
                                                    }
                                                }}
                                                fullWidth
                                                type="text"
                                                name="remark"
                                                size='small'
                                                onChange={handleChange}
                                                value={(data.remark)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Accordion style={{ boxShadow: 'none' }} defaultExpanded={editid}>
                                                <AccordionSummary style={{ padding: '0px', maxWidth: '120px' }}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography sx={{ color: 'blue', fontSize: '12px', textDecoration: 'underline', padding: 'none' }}>Terms & conditions </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ padding: '0px' }} className={`${styles.custom_scrollbar}`}>
                                                    <Box className={`${styles.custom_scrollbar_content}`}>
                                                        {rowsTerms && rowsTerms.map((row, index) => {
                                                            return (
                                                                <Grid container spacing={0} sx={{ mt: 0 }}>
                                                                    <Grid item xs={12}>
                                                                        <Box style={{ display: 'flex' }}>
                                                                            <Checkbox
                                                                                sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px' }}
                                                                                size="small"
                                                                                name="trueFalse"
                                                                                value={row.trueFalse}
                                                                                defaultChecked={row.trueFalse}
                                                                                onChange={(event) => handleChangeTerms(event, index)}
                                                                            />
                                                                            {/* <Typography className={`${styles.erp_lable}`} style={{paddingRight: '10px',}}>{index + 1}. </Typography> */}
                                                                            <Typography className={`${styles.erp_lable}`} style={{ paddingBottom: '4px' }}>  {row.termsAndConditions}</Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Box>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6} >
                                    <Grid container spacing={0} sx={{ mt: 1.5, }}>
                                        <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography style={{ fontWeight: 'bold', fontSize: '14px', }} >Basic Amount </Typography>
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        "& input": {
                                                            textAlign: "right",
                                                            fontSize: '14px',
                                                            fontWeight: 'bold',
                                                        }
                                                    }
                                                }}
                                                variant="standard"
                                                required
                                                type="number"
                                                name="basicTotal"
                                                onChange={handleChange}
                                                value={parseFloat(basicTotal).toFixed(2)}
                                                size='small'
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                        {invoiceSetting.showDiscountPer_header === 'true' &&
                                            <>

                                                <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Checkbox
                                                        sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                        size="small"
                                                        name="discount_show"
                                                        value={discount_show}
                                                        defaultChecked={discount_show}
                                                        onChange={(event) => handleChangeDiscount_show(event)}
                                                    />
                                                    <Typography className={`${styles.erp_lable}`}>Discount % </Typography>
                                                </Grid>
                                                <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="totalDiscountPer"
                                                        onChange={handleChangeTotalDiscountPer}
                                                        value={(totalDiscountPer)}
                                                        size='small'
                                                        InputProps={{
                                                            readOnly: discount_show == false ? true : false,
                                                        }}
                                                    // InputProps={{
                                                    //     disableUnderline: true,
                                                    // }}

                                                    />
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Typography className={`${styles.erp_lable}`}>Discount Amount </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="totalDiscountAmt"
                                                        value={parseFloat(totalDiscountAmt).toFixed(2)}
                                                        size='small'
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        }


                                        {invoiceSetting.showPackingForwarding === 'true' &&
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Checkbox
                                                        sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                        size="small"
                                                        name="packing_forwarding_show"
                                                        value={packing_forwarding_show}
                                                        defaultChecked={packing_forwarding_show}
                                                        onChange={(event) => handleChangePacking_forwarding_show(event)}
                                                    />
                                                    <Typography className={`${styles.erp_lable}`}>Packing & Forwarding </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="packing_forwarding"
                                                        onChange={handleChangePackingForwarding}
                                                        value={packing_forwarding}
                                                        size='small'
                                                        InputProps={{
                                                            readOnly: packing_forwarding_show == false ? true : false,
                                                        }}
                                                    // InputProps={{
                                                    //     disableUnderline: true,
                                                    // }}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                        {invoiceSetting.showFreightCharges === 'true' &&
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Checkbox
                                                        sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                        size="small"
                                                        name="freight_charges_show"
                                                        value={freight_charges_show}
                                                        defaultChecked={freight_charges_show}
                                                        onChange={(event) => handleChangeFreight_charges_show(event)}
                                                    />
                                                    <Typography className={`${styles.erp_lable}`}>Freight Charges </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="freight_charges"
                                                        onChange={handleChangeFreightCharges}
                                                        value={freight_charges}
                                                        size='small'
                                                        InputProps={{
                                                            readOnly: freight_charges_show == false ? true : false,
                                                        }}
                                                    // InputProps={{
                                                    //     disableUnderline: true,
                                                    // }}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                        {invoiceSetting.showTempoCharges === 'true' &&
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Checkbox
                                                        sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                        size="small"
                                                        name="tempo_charges_show"
                                                        value={tempo_charges_show}
                                                        defaultChecked={tempo_charges_show}
                                                        onChange={(event) => handleChangeTempo_charges_show(event)}
                                                    />
                                                    <Typography className={`${styles.erp_lable}`}>Tempo Charges </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="tempo_charges"
                                                        onChange={handleChangeTempoCharges}
                                                        value={tempo_charges}
                                                        size='small'
                                                        InputProps={{
                                                            readOnly: tempo_charges_show == false ? true : false,
                                                        }}
                                                    // InputProps={{
                                                    //     disableUnderline: true,
                                                    // }}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                        {invoiceSetting.showOtherCharges === 'true' &&
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Checkbox
                                                        sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px', color: '#ff8000' }}
                                                        size="small"
                                                        name="other_charges_show"
                                                        value={other_charges_show}
                                                        defaultChecked={other_charges_show}
                                                        onChange={(event) => handleChangeOther_charges_show(event)}
                                                    />
                                                    <Typography className={`${styles.erp_lable}`}>Other Charges </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="other_charges"
                                                        onChange={handleChangeOtherCharges}
                                                        value={other_charges}
                                                        size='small'
                                                        InputProps={{
                                                            readOnly: other_charges_show == false ? true : false,
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        }

                                        <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography style={{ fontWeight: 'bold', fontSize: '14px', marginTop: '2px' }} >Assessable Amount </Typography>
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', }}  >
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="assessableAmt"
                                                value={parseFloat(assessableAmt).toFixed(2)}
                                                size='small'
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        "& input": {
                                                            marginTop: '6px',
                                                            textAlign: "right",
                                                            fontSize: '14px',
                                                            fontWeight: 'bold',
                                                        }
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>GST % </Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="gst"
                                                onChange={handleChangeGST}
                                                value={gst}
                                                size='small'
                                                // InputProps={{
                                                //     disableUnderline: true,
                                                // }}
                                                onInput={(e) => {
                                                    const inputValue = Math.max(0, Math.min(100, parseInt(e.target.value)));
                                                    e.target.value = inputValue.toString().slice(0, 3);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>GST Amount </Typography>
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="gstTotal"
                                                size='small'
                                                onChange={handleChange}
                                                value={parseFloat(gstTotal).toFixed(2)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>

                                        {/* =====================================================================
                                        <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>CGST Amount </Typography>
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="cgstTotal"
                                                size='small'
                                                onChange={handleChange}
                                                value={parseFloat(cgstTotal).toFixed(2)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>SGST Amount </Typography>
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="sgstTotal"
                                                size='small'
                                                onChange={handleChange}
                                                value={parseFloat(sgstTotal).toFixed(2)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>IGST Amount </Typography>
                                        </Grid>
                                        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="igstTotal"
                                                size='small'
                                                onChange={handleChange}
                                                value={parseFloat(igstTotal).toFixed(2)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                    ====================================================================== */}

                                        {invoiceSetting.showRoundOff === 'true' &&
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Typography className={`${styles.erp_lable}`}>Total Amount </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="total"
                                                        value={parseFloat(total).toFixed(2)}
                                                        size='small'
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Typography className={`${styles.erp_lable}`}>Round Off </Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ERPinputNo
                                                        variant="standard"
                                                        required
                                                        type="number"
                                                        name="round_off"
                                                        value={round_off == null ? 0 : parseFloat(round_off).toFixed(2)}
                                                        size='small'
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                        {invoiceSetting.showRoundOff === 'true' ?
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                    <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Invoice Amount</Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                    <ERPinputNo
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                height: 38,
                                                                "& input": {
                                                                    textAlign: "right",
                                                                    fontSize: '22px',
                                                                    fontWeight: 'bold',
                                                                    color: '#000000'
                                                                }
                                                            }
                                                        }}
                                                        variant="standard"
                                                        type="number"
                                                        name="total"
                                                        size='small'
                                                        onChange={handleChange}
                                                        value={parseFloat(Math.round(total)).toFixed(2)}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                            :
                                            <>
                                                <Grid item xs={9} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                    <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Invoice Amount</Typography>
                                                </Grid>
                                                <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                                    <ERPinputNo
                                                        sx={{
                                                            "& .MuiInputBase-root": {
                                                                height: 38,
                                                                "& input": {
                                                                    textAlign: "right",
                                                                    fontSize: '22px',
                                                                    fontWeight: 'bold',
                                                                    color: '#000000'
                                                                }
                                                            }
                                                        }}
                                                        variant="standard"
                                                        type="number"
                                                        name="total"
                                                        size='small'
                                                        onChange={handleChange}
                                                        value={parseFloat(total).toFixed(2)}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Box sx={{ marginTop: '12px', float: 'right', }}>
                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                </Button>
                                <Cancel />
                            </Box>
                        </Box>
                    </form>
                </Paper>
            </div>
            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }
        </>
    )
}


export default DemoFile